import { Box } from "@mui/material";
import { LanguageContext } from "../../../context/LanguageContext";
import React, { useContext } from "react";
import { ParagraphText } from "../../../Libraries";

const HeaderItem = () => {
  const [I18n] = useContext(LanguageContext);

  return (
    <Box className="invoiceListTableHeader">
      <Box className="invListTableHeaderCol sixColumn textLeft">
        <ParagraphText className="fontSize12 fontWeight500 newLightColor">
          {I18n.date}
        </ParagraphText>
      </Box>
      <Box className="invListTableHeaderCol sixColumn textLeft">
        <ParagraphText className="fontSize12 fontWeight500 newLightColor">
          {I18n.description}
        </ParagraphText>
      </Box>
      <Box className="invListTableHeaderCol sixColumn textRight">
        <ParagraphText className="fontSize12 fontWeight500 newLightColor">
          {I18n.debit}
        </ParagraphText>
      </Box>
      <Box className="invListTableHeaderCol sixColumn textRight">
        <ParagraphText className="fontSize12 fontWeight500 newLightColor">
          {I18n.credit}
        </ParagraphText>
      </Box>
      <Box className="invListTableHeaderCol sixColumn textRight">
        <ParagraphText className="fontSize12 fontWeight500 newLightColor">
          {I18n.balance}
        </ParagraphText>
      </Box>
      <Box className="invListTableHeaderCol sixColumn textCenter" >
        <ParagraphText className="fontSize12 fontWeight500 newLightColor">
          {I18n.actions}
        </ParagraphText>
      </Box>

    </Box>
  );
};

export default HeaderItem;
